
export class PreviewItem {
    name?: string;
    path?: string;

    constructor(source?: any) {
        if (source) {
            this.name = source.name;
            this.path = source.path;
        }
    }
}
